// import React from "react";
// import "./blueParagraph.css";

// export default function TypewriterAnimation() {
  

//   return (
//     <div
//       // className="blueArea"
//       style={{ backgroundColor: "#f5f5f5", color: "#404040" }}
//       id="next-section"
//     >
//           <div
//             className="conservepage-para"
//             id="parent"
//             data-aos="fade-in"
//             data-aos-duration="1000"
//             data-aos-once="true"
//           >
//             <h1 style={{ marginBottom: "20px", marginTop:"20px" }}>CONSERVE <span className="white-box-container-h1">THE ENVIRONMENT</span></h1>
//             <p className="parag">
//               We all share one world. Taking care of it is everyone’s responsibility. 
//                 <br />
//               Hirdaramani doesn’t shy away from these responsibilities. We never have and never will. 
//               Sustainability has always been an important part of our business and is deeply ingrained in our DNA. 
//               It has been a rewarding journey from the very beginning, but it transitioned into a greater mission in 2006 when we developed 
//               our first environmental roadmap. 

//             </p>
//             <p className="parag">
//               Within the global apparel industry, we’re encouraged to see manufacturers and brands embrace 
//               more sustainable practices as part of an evolving journey. Similarly, we are constantly exploring new technologies 
//               and adapting our processes to meet these advancing standards.
//             </p>
//             <p className="parag">
//               From the way we manufacture to the products and solutions that we create, we hold ourselves 
//               accountable to a set of 
//               global standards designed to foster the sustainability of our planet.
//             </p>
//           </div>
//     </div>
//   );
// }


import React from "react";
import "./blueParagraph.css";
import Conserve from "../../assets/Conserve_The_Environment._Minimalist_World.webp";


export default function TypewriterAnimation() {
  return (
    <div
      style={{ backgroundColor: "#f5f5f5", color: "#404040" }}
      id="next-section"
      className="blueArea"
    >
      <div className="conservepage-container">
        {/* Left Column */}
        <div className="conservepage-left" data-aos="fade-in" data-aos-duration="1000" data-aos-once="true">
          <h1 style={{ marginBottom: "30px", marginTop: "30px" }}>
            Conserve <span className="white-box-container-h1">The Environment</span>
          </h1>
          <p className="parag">
            We all share one world. Taking care of it is everyone’s responsibility. <br />
            Hirdaramani doesn’t shy away from these responsibilities. We never have and never will.
            Sustainability has always been an important part of our business and is deeply ingrained in our DNA.
            It has been a rewarding journey from the very beginning, but it transitioned into a greater mission in 2006 when we developed
            our first environmental roadmap.
          </p>
          <p className="parag">
            Within the global apparel industry, we’re encouraged to see manufacturers and brands embrace
            more sustainable practices as part of an evolving journey. Similarly, we are constantly exploring new technologies
            and adapting our processes to meet these advancing standards.
          </p>
          <p className="parag">
            From the way we manufacture to the products and solutions that we create, we hold ourselves
            accountable to a set of global standards designed to foster the sustainability of our planet.
          </p>
        </div>

        {/* Right Column */}
        <div className="conservepage-right">
          <img
            src={Conserve}
            alt="Environment Conservation"
            className="conserve-image"
          />
        </div>
      </div>
    </div>
  );
}
